<div class="container-fluid p-3">

  <!-- Welcome -->
  <div class="mb-3 d-flex justify-content-between align-items-center">
    <h2 class="fw-semibold mb-0">ZignFlix Admin Dashboard</h2>
    <button mat-button class="btn" (click)="refreshDashboard()"><mat-icon class="m-0 p-0">refresh</mat-icon></button>
  </div>

  <!-- ================= KPI CARDS ================= -->
  <div class="row g-3 mb-4">

    <div class="col-md-3">
      <div class="card dashboard-card text-center">
        <h6 class="text-muted">Total Business</h6>
        <h2 class="fw-bold">{{ total }}</h2>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card dashboard-card text-center text-success">
        <h6 class="text-muted">Active Business</h6>
        <h2 class="fw-bold">{{ active }}</h2>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card dashboard-card text-center text-warning">
        <h6 class="text-muted">Business in Trial</h6>
        <h2 class="fw-bold">{{ trial }}</h2>
      </div>
    </div>

    <div class="col-md-3">
      <div class="card dashboard-card text-center text-danger">
        <h6 class="text-muted">Expired Business</h6>
        <h2 class="fw-bold">{{ expired }}</h2>
      </div>
    </div>

  </div>

  <!-- ================= TOP ROW ================= -->
  <div class="row g-3 mb-4">

    <!-- LEFT SIDE -->
    <div class="col-lg-4">

      <!-- Quick Actions -->
      <div class="card dashboard-card mb-3">
        <h5 class="mb-3">Quick Actions</h5>

        <div class="row g-2">

          <div class="col-4">
            <div class="card action-card text-center" (click)="goToBusinessList()">
              <small>All</small>
              <h5>{{ total }}</h5>
            </div>
          </div>

          <div class="col-4">
            <div class="card action-card text-center border-warning" (click)="openTrialBusinesses()">
              <small class="text-warning">Trial</small>
              <h5>{{ trial }}</h5>
            </div>
          </div>

          <div class="col-4">
            <div class="card action-card text-center border-danger" (click)="openExpiredBusinesses()">
              <small class="text-danger">Expired</small>
              <h5>{{ expired }}</h5>
            </div>
          </div>

        </div>
      </div>

      <!-- Chart -->
      <div class="card dashboard-card mb-0">
        <h5 class="mb-3">Business Summary</h5>

        <div class="chart-container">
          <div class="chart-wrapper">
            <canvas id="businessChart"></canvas>
          </div>
        </div>
      </div>

    </div>

    <!-- RIGHT SIDE -->
    <div class="col-lg-8">
      <!-- ================= SCREEN SUMMARY ================= -->
      <div class="card dashboard-card">
        <h5 class="mb-3">Screen Summary</h5>

        <div class="row g-2 text-center">

          <!-- TOTAL -->
          <div class="col-3">
            <div class="card action-card screen-total" (click)="openAllScreens()">
              <small>Total</small>
              <h5>{{ totalScreens }}</h5>
            </div>
          </div>

          <!-- LIVE -->
          <div class="col-3">
            <div class="card action-card screen-live" (click)="openLiveScreens()">
              <small>Live</small>
              <h5>{{ liveScreens }}</h5>
            </div>
          </div>

          <!-- STANDBY -->
          <div class="col-3">
            <div class="card action-card screen-standby" (click)="openStandbyScreens()">
              <small>Standby</small>
              <h5>{{ standbyScreens }}</h5>
            </div>
          </div>

          <!-- INACTIVE -->
          <div class="col-3">
            <div class="card action-card screen-inactive" (click)="openInactiveScreens()">
              <small>Inactive</small>
              <h5>{{ inactiveScreens }}</h5>
            </div>
          </div>

        </div>
      </div>
      <div class="card dashboard-card mt-3">

        <div class="d-flex justify-content-between align-items-center mb-2">
          <div class="row w-100">
            <div class="col-10">
              <h5 class="mb-0">Expiring Soon</h5>
            </div>
            <div class="col-2">
              <select class="form-select form-select-sm expiry-dropdown" [(ngModel)]="selectedRange"
                (change)="updateExpiryData()">

                @for (option of expiryOptions; track option) {
                  <option [value]="option.value">
                    {{ option.label }}
                  </option>
                }

              </select>
            </div>
          </div>
        </div>

        <div class="table-container expiring-soon">
          <table class="table table-hover table-sm align-middle mb-0">

            <thead class="table-light position-sticky top-0">
              <tr>
                <th>Business</th>
                <th>Email</th>
                <th class="text-center">Expiry</th>
              </tr>
            </thead>

            <tbody>

              @if (expiringSoon.length > 0) {
                @for (b of expiringSoon; track b.id) {
                  <tr>
                    <td class="fw-medium">{{ b.name }}</td>
                    <td>{{ b.business_admin_email }}</td>
                    <td class="text-center text-danger">
                      {{ b.expiry_date | dateFormat }}
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td colspan="3" class="text-center text-muted">
                    No businesses expiring soon
                  </td>
                </tr>
              }

            </tbody>

          </table>
        </div>

      </div>
    </div>

  </div>

  <!-- ================= RECENT BUSINESSES ================= -->
  <div class="card dashboard-card" appDynamicHeight [offset]="760" [minHeight]="190">

    <div class="d-flex justify-content-between align-items-center mb-2">
      <h5 class="mb-0">Recent Businesses</h5>
    </div>

    <div class="table-container large">
      <table class="table table-hover align-middle mb-0">

        <thead class="table-light position-sticky top-0">
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th class="text-center">Created</th>
          </tr>
        </thead>

        <tbody>

          @if (recentBusinesses.length > 0) {
            @for (b of recentBusinesses; track b.id) {
              <tr>
                <td class="fw-medium">{{ b.name }}</td>
                <td>{{ b.business_admin_email }}</td>

                <td>
              <span class="badge" [ngClass]="{
                    'bg-success': b.status === 'live',
                    'bg-warning text-dark': b.status === 'trial',
                    'bg-secondary': b.status !== 'live' && b.status !== 'trial'
                  }">
                    {{ b.status | uppercase }}
                  </span>
                </td>

                <td class="text-center">
                  {{ b.created_at | dateFormat }}
                </td>
              </tr>
            }
          } @else {
            <tr>
              <td colspan="4" class="text-center text-muted">
                No recent businesses
              </td>
            </tr>
          }

        </tbody>

      </table>
    </div>

  </div>

</div>